import type { Bet } from '@/lib/mobx/models/Bet.mobx';
import { topEventsLines } from '@/config/constants';

const normalizeTopEventMarketId = (id: string) => {
  const [line, ...rest] = id.split('.');

  if (!topEventsLines.has(line as string)) {
    return id;
  }

  let formattedLine = '';
  if (line === '4') {
    formattedLine = '1';
  } else {
    formattedLine = '2';
  }

  return [formattedLine, ...rest].join('.');
};

/**
 * Normalizes bet object for local storage by adjusting eventId, pid, and pidLid.
 * If bet belongs to top events lines, their line identifiers are modified accordingly
 * to normal line identifiers.
 *
 * @param {Object} bet - The bet object to normalize.
 * @returns {Object} - The normalized bet object.
 */
export const normalizeBetForLocalStorage = (bet: Bet) => {
  const { eventId, pid, pidLid } = bet;

  return {
    ...bet,
    eventId: normalizeTopEventMarketId(eventId),
    pid: normalizeTopEventMarketId(pid),
    pidLid: normalizeTopEventMarketId(pidLid),
  };
};
